'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var VUE_APOLLO_QUERY_KEYWORDS = exports.VUE_APOLLO_QUERY_KEYWORDS = ['variables', 'watch', 'update', 'result', 'error', 'loadingKey', 'watchLoading', 'skip', 'throttle', 'debounce', 'subscribeToMore'];


//////////////////
// WEBPACK FOOTER
// ./~/vue-apollo/lib/consts.js
// module id = 830
// module chunks = 0